<template>
  <div>
     <ul class="modele-con">
        <li v-for="(item,index) in list" :key="index" @click="handleDetail(item.name,item.id)">
            <!-- <img class="img-right" :src="cdnUrl + 'FvYZm8iFlimFsyKybjOsilO_C45I'" alt=""> -->
            <img class="img-icon" :src="cdnUrl + item.img" alt="">
            <p class="model-tip">{{ item.title }}</p>
        </li>
    </ul>
    <footerLine></footerLine>
    <!-- <img class="bgc-img" :src="cdnUrl + 'Fh0qs3EaUeTZH60HjevzW7bWeh48'" alt=""> -->
  </div>
</template>

<script>
import { centrifugeRecord } from '@/libs/common'
import footerLine from '@/components/footerLine'
export default {
    components:{ footerLine },
    data() {
        return {
            cdnUrl: this.$config.baseUrl.cdnUrl,
            cdnUrlPro: this.$config.baseUrl.pro,
            list: [
                {img: 'FnRETn9LNleivAR1S5Gj3gcIY2Tj',title: '移液器选型',name: 'filterProduct',id: '112'},
                {img: 'FisIwT8UnCcxl2oiGrZBcaX-WP8i',title: '吸头选型',name: 'sucker'},
                // {img: 'FoHpqgcUPAcGGYMbep6BPt9LGpNB',title: 'Lavibe适配吸头',name: 'jump'},
            ],
        }
    },
    methods: {
        handleDetail(name,id) {
            if(!name) {
                this.$toast('敬请期待')
                return
            }
           
            if (name == 'jump') {
                window.location.href = `${this.cdnUrlPro}/pageTurnings/index.html?id=517&d=&productType=2`
            } else {
                this.$router.push({
                    name: name,
                    query: {
                        category_id: id
                    }
                })
            }
            let para = {
                type: name == 'filterProduct'? 25 : (name == 'sucker' ? 26 : 27), // 25 移液器选型 26 吸头选型 27 Lavibe适配吸头
                uid: this.$store.state.user.id || 0,
                action: 1,
                type_id: 0
            }
            centrifugeRecord(para)
        }
    }
}
</script>

<style lang="scss" scoped>
.modele-con {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
    li {
        display: flex;
        justify-content: flex-end;
        align-items: center;
        position: relative;
        width: rem(343);
        height: rem(116);
        margin-top: rem(20);
        padding-left: rem(55);
        background: #F8FEFF;
        box-shadow: 0px 2px 6px 0px rgba(102,102,102,0.5);
        border-radius: 6px;
        box-sizing: border-box;
    }
    li{
        // padding-right: rem(64);
    }
    .model-tip {
        flex: 1;
        text-align: center;
        font-size: rem(21);
        font-weight: bold;
        color: #333333c7;
    }
    .img-icon {
        width: rem(66);
        height: rem(66);
    }
    .img-right {
        position: absolute;
        bottom: 0;
        right: 0;
        width: rem(73);
        height: rem(58);
    }
}
.bgc-img {
    position: absolute;
    bottom: 0;
    right: 0;
    width: rem(232);
    height: rem(262);
}
</style>